import React, {useState} from 'react'
import Grid from '@material-ui/core/Grid';
import { Checkmark } from 'react-checkmark'
import { BsQuestionCircle } from 'react-icons/bs'

const ColumnStatus = ({complete}) => {
//const [complete, setComplete] = useState(false)

//setComplete(handleChange);

const renderColumnStatus = () =>{
    if (complete){
        return <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        //  justify="center"
        item xs
        style={{paddingTop: '14px'}} >
                <Checkmark size='32px'/><br/><br/>
        </Grid>
    }
    else {
        return <Grid 
        container
        spacing={0}
        direction="column"
        alignItems="center"
        //  justify="center"
        item xs
        style={{}} >
            {/*<span><i className="fa fa-circle" style={{color:'#396793',fontSize:'2em'}}>1</i></span><br/><br/><br/>*/}
            <span style={{fontSize: '2em'}}><BsQuestionCircle/></span><br/><br/>
        </Grid>
    }
}

    return (
        <div>
            {renderColumnStatus(complete)}
        </div>
    )
}

export default ColumnStatus
